import { render, staticRenderFns } from "./aztec1000.vue?vue&type=template&id=f464053a&scoped=true"
import script from "./aztec1000.vue?vue&type=script&lang=js"
export * from "./aztec1000.vue?vue&type=script&lang=js"
import style0 from "./aztec1000.vue?vue&type=style&index=0&id=f464053a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f464053a",
  null
  
)

export default component.exports